(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // header here refers to the section wrapper element (the element with class "section-header" added by Shopify),
      // that element will receive the sticky / hidden classes. The inner <header class="header"> will be styled via CSS.
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.template = this.getAttribute('data-template') || '';

      // fallback: if .section-header not found, try the current element (custom element) itself
      if (!this.header) {
        this.header = this;
      }

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();

      // Create hero observer for homepage behavior
      this.createHeroObserver();
    }

    setHeaderHeight() {
      // set a CSS variable with header height for any layout use
      const headerEl = this.header.querySelector ? this.header.querySelector('.header') : null;
      const height = headerEl ? headerEl.offsetHeight : (this.header.offsetHeight || 0);
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.heroObserver) {
        this.heroObserver.disconnect();
      }
      if (this._boundsObserver) {
        this._boundsObserver.disconnect();
      }
    }

    createObserver() {
      // Observes the section wrapper's bounds to get top/bottom values used in onScroll
      this._boundsObserver = new IntersectionObserver((entries, observer) => {
        if (!entries || !entries[0]) return;
        this.headerBounds = entries[0].intersectionRect || {};
        // disconnect after first measurement
        observer.disconnect();
      });

      // Observe the header element to measure initial intersectionRect
      this._boundsObserver.observe(this.header);
    }

    createHeroObserver() {
      // Only apply hero-specific behavior on the index (homepage)
      this.heroVisible = false;

      // Only proceed if template is index
      if (this.template !== 'index') return;

      // Try common hero selectors - keep it flexible for different themes
      const heroSelectors = [
        '[data-section-type="hero"]',
        '.hero',
        '.section-hero',
        '.shopify-section-hero',
        '[id^="hero"]',
        '[class*="hero-"]'
      ];

      let hero = null;
      for (let sel of heroSelectors) {
        hero = document.querySelector(sel);
        if (hero) break;
      }

      if (!hero) {
        // If hero not found, we'll fallback to previous behavior (header bounds)
        this.heroVisible = false;
        return;
      }

      // Observe the hero element's intersection with viewport
      this.heroObserver = new IntersectionObserver(
        (entries) => {
          if (!entries || !entries[0]) return;
          const entry = entries[0];
          // Consider hero visible if any part of it is intersecting
          this.heroVisible = entry.isIntersecting && entry.intersectionRatio > 0;
          // When hero becomes visible, reset header to absolute/transparent
          if (this.heroVisible) {
            // remove sticky / hidden classes so header returns to absolute transparent
            this.header.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate', 'scrolled-past-header');
            // ensure height stays accurate
            this.setHeaderHeight();
          } else {
            // When hero is not visible, enable sticky behavior (but don't force reveal/hide here)
            if (!this.headerIsAlwaysSticky) {
              // we add sticky class so CSS makes header fixed
              this.header.classList.add('shopify-section-header-sticky');
            }
            this.setHeaderHeight();
          }
        },
        {
          root: null,
          threshold: [0, 0.01, 0.25, 0.5, 1]
        }
      );

      this.heroObserver.observe(hero);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // If on homepage and hero is visible, ensure header is absolute transparent and reset state
      if (this.template === 'index' && this.heroVisible) {
        // If hero in view, always ensure header isn't sticky or hidden
        if (this.header.classList.contains('shopify-section-header-sticky') || this.header.classList.contains('shopify-section-header-hidden')) {
          this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'scrolled-past-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      // If header bounds not measured, fallback to simple behavior
      const headerBottom = (this.headerBounds && this.headerBounds.bottom) ? this.headerBounds.bottom : 0;
      const headerTop = (this.headerBounds && this.headerBounds.top) ? this.headerBounds.top : 0;

      // If scrolling down and past header bottom -> hide (only if not always sticky)
      if (scrollTop > this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      }
      // If scrolling up and scrolled past header bottom -> show
      else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      }
      // If scrolled back to the top (or before header top), reset to absolute/initial state
      else if (scrollTop <= headerTop) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      // add hidden and sticky classes to enable transform-based hide
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.classList.remove('animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      // show header (sticky + animate), remove hidden
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      // reset so header returns to initial (absolute on homepage or non-sticky on other pages)
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'scrolled-past-header');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close && disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal && this.searchModal.close && this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
